function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.49996 9.16667C5.65901 9.16667 4.16663 7.67428 4.16663 5.83333C4.16663 3.99238 5.65901 2.5 7.49996 2.5C9.34091 2.5 10.8333 3.99238 10.8333 5.83333C10.8333 7.67428 9.34091 9.16667 7.49996 9.16667ZM15.8333 9.16667C15.373 9.16667 15 8.79358 15 8.33334V6.66667H13.3333C12.8731 6.66667 12.5 6.29358 12.5 5.83334C12.5 5.3731 12.8731 5.00001 13.3333 5.00001H15V3.33334C15 2.8731 15.373 2.50001 15.8333 2.50001C16.2935 2.50001 16.6666 2.8731 16.6666 3.33334V5.00001H18.3333C18.7935 5.00001 19.1666 5.3731 19.1666 5.83334C19.1666 6.29358 18.7935 6.66667 18.3333 6.66667H16.6666V8.33334C16.6666 8.79358 16.2935 9.16667 15.8333 9.16667Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.00054307 16.8327C0.323549 12.8554 3.55159 10.8333 7.48612 10.8333C11.476 10.8333 14.7541 12.7443 14.9983 16.8333C15.008 16.9962 14.9983 17.5 14.3722 17.5C11.2843 17.5 6.6956 17.5 0.606252 17.5C0.39726 17.5 -0.0170515 17.0493 0.00054307 16.8327Z"
});

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.010e8f34.svg";
export { ForwardRef as ReactComponent };